// src/redux/store.js
import { createStore } from "redux";
import rootReducer from "./rootReducer";

const devtools =
    typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : undefined;

const store = createStore(rootReducer, devtools as undefined);

export default store;
